/**
 * Getters for groups
 */
export const getters = {
  getSelected(state) {
    return state.selected;
  },
  getIsVideo(state) {
    return state.isVideo;
  }
};
